import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-super-lib',
  template: `
    <p>
      super-lib works!
    </p>
  `,
  styles: []
})
export class SuperLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
